// extracted by mini-css-extract-plugin
export var actions = "_lp-d";
export var benefitCard = "_lp-a";
export var benefitIcon = "_lp-b";
export var benefitLabel = "_lp-c";
export var benefits = "_lp-9";
export var bodyText = "_lp-8";
export var closeButton = "_lp-2";
export var content = "_lp-3";
export var eyebrow = "_lp-4";
export var heading = "_lp-5";
export var image = "_lp-f";
export var imagePanel = "_lp-e";
export var modal = "_lp-0";
export var shell = "_lp-1";
export var title = "_lp-6";
export var titleOffer = "_lp-7";